// prettier-ignore
export default {barcode: new RegExp("^[0-9]+X[a-zA-W0-9]+Y{0,1}[a-zA-Z0-9]*$"), divider: /[.,| ]+/g}